import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { Platform } from '@ionic/angular';
import { PlayerHomeInfo } from '../../data/player-data';
import { MessageDisplayUtil } from '../../message-display-utils';
import { ConnectionService } from '../../providers/connection-service/connection-service';
import { PlayerService } from '../../providers/player-service/player-service';
import { AppState } from '../appstate';
import { createAction } from '../create-action';
import { CurrentScorecardActions } from '../scorecard/current-scorecard-actions';
import { CurrentScorecardDataService } from '../scorecard/current-scorecard-data-service';
// import {PlainScorecard} from '../../data/scorecard';
import { PlayerHomeData } from './player-home-data';
import { CompetitionInfo } from '../../data/competition-data';
import * as moment from 'moment';
import { ServerResult } from '../../data/server-result';
import { Observable } from 'rxjs';
import { UploadResult } from '../../data/fileupload-result';
// import { JsonService } from '../../json-util';
import { JsonService } from '../../json-util';
// import { JsonService } from '../../json-util';
import { CompetitionService } from '../../providers/competition-service/competition-service';
import { CurrentScorecard } from '../scorecard/current-scorecard';
import { SessionDataService } from '../session/session-data-service';
import { SessionState, SessionInfo } from '../../data/authentication-info';
import { ClubFlightService } from '../../providers/club-flight-service/club-flight-service';
import { SessionActions } from '../session';
import { PlayerInfo, PlainScoreCard } from '../../data/mygolf.data';
import { PlayerHomeDataService } from './player-home-data-service';
import {
  WebsocketActions,
  SUBSCRIBE_TEETIME_BOOKING,
  SUBSCRIBE_COMP_MATCHPLAY_HOLE_SYNCED,
  SUBSCRIBE_COMP_MATCHPLAY_SUBMITTED,
  SUBSCRIBE_COMP_MATCHPLAY_UPDATED,
  SUBSCRIBE_COMP_MATCHPLAY_UPDATE_SCORER,
  SUBSCRIBE_COMP_SHOW_LEADERBOARD,
  SUBSCRIBE_COMP_SCORE_SYNCED,
  SUBSCRIBE_FLIGHT_CHANGE,
  SUBSCRIBE_DEVICE_LOCK_BROKEN,
} from '../wstomp';
import { distinctUntilChanged, take } from 'rxjs/operators';
import { filter } from 'rxjs/operators';
import { map } from 'rxjs/operators';
/**
 * Created by ashok on 11/05/17.
 */

@Injectable()
export class PlayerHomeActions {
  public static REFRESH_HOME = 'REFRESH_PLAYER_HOME';
  public static SET_NEED_REFRSH = 'SET_NEED_REFRESH';
  public static REFRESH_HOME_SUCCESS = 'REFRESH_HOME_SUCESS';
  public static REFRESH_HOME_FAILED = 'REFRESH_HOME_FAILED';
  public static CHECK_SCORECARD = 'PLAYER_HOME_CHECKSCORECARD';
  public static SELECT_COMPETITION_FOR_SCORING = 'SELECT_COMPETITION_FOR_SCORING';
  public static SET_SELECTED_COMPETITION = 'SET_SELECTED_COMPETITION';
  public static RESET_STATE = 'RESET_HOME_STATE';
  public static SET_HOME_STATE = 'SET_PLAYER_HOME_STATE';
  public static SET_PLAYER_INFO = 'SET_PLAYER_INFO';
  public static UPDATE_PLAYER_PROFILE = 'UPDATE_PLAYER_PROFILE';
  public static UPDATE_PLAYER_PHOTO = 'UPDATE_PLAYER_PHOTO';
  public static CLEAR_ALL_STATES = 'CLEAR_ALL_STATES';

  constructor(
    private store: Store<AppState>,
    private platform: Platform,
    private connService: ConnectionService,
    private currScorecardActions: CurrentScorecardActions,
    private currScorecardService: CurrentScorecardDataService,
    private sessionService: SessionDataService,
    private playerService: PlayerService,
    private competitionService: CompetitionService,
    private flightService: ClubFlightService,
    private sessionActions: SessionActions,
    private websocketActions: WebsocketActions
  ) {}

  public refreshForcefully() {
    this.store.dispatch(createAction(PlayerHomeActions.SET_NEED_REFRSH, true));
    // setTimeout(() => {
    //     // this.store.dispatch(createAction(PlayerHomeActions.REFRESH_HOME_SUCCESS, true))
    //     this.setState("")
    //   }, 5000)
    this.refreshHomeInfo();
  }
  public refreshHomeInfo() {
    //first send refresh home

    this.sessionService
      .getSessionStatus()
      .pipe(take(1))
      .subscribe((state: SessionState) => {
        switch (state) {
          case SessionState.LoggedIn:
            this.store
              .select((appState: any) => appState.reducers.playerHomeData.needToRefresh)
              .pipe(distinctUntilChanged())
              .pipe(take(1))
              .pipe(filter(needRefresh => needRefresh))
              .subscribe(needToRefresh => {
                this.store.dispatch(createAction(PlayerHomeActions.REFRESH_HOME));
                this.playerService.getHomeInfo().subscribe(
                  (playerHomeInfo: PlayerHomeInfo) => {
                    if (playerHomeInfo && playerHomeInfo.compsActiveToday) {
                      if (playerHomeInfo.compsActiveToday.length > 1) {
                        playerHomeInfo.compsActiveToday = playerHomeInfo.compsActiveToday.reverse();
                      }
                    }
                    this.store.dispatch(
                      createAction(PlayerHomeActions.REFRESH_HOME_SUCCESS, playerHomeInfo)
                    );
                    this.setNeedRefresh(false);
                    this.initWebsocketActions();
                    let _scorecardType = ''; // 'NormalGame'
                    this.fetchCurrentScorecard(playerHomeInfo, _scorecardType).subscribe(
                      (scorecard: PlainScoreCard) => {
                        if (!scorecard) this.setState('');
                        if (scorecard) this.checkCompetitionScoring(scorecard);
                        setTimeout(() => {
                          this.setState('');
                        }, 5000);
                      },
                      error => {
                        this.setState('');
                      },
                      () => {
                        this.setState('');
                      }
                    );
                  },
                  error => {
                    let msg = MessageDisplayUtil.getError(
                      error,
                      this.platform,
                      this.connService,
                      'Server may be down.'
                    );
                    msg = 'Error refreshing home information. ' + msg;
                    this.store.dispatch(createAction(PlayerHomeActions.REFRESH_HOME_FAILED, msg));
                    if (error.status === 403) {
                      this.sessionService
                        .getSession()
                        .pipe(take(1))
                        .subscribe((session: SessionInfo) => {
                          if (session && session.password) {
                            this.sessionActions.login(session.userName, session.password);
                          } else if (session && !session.password) {
                            this.sessionActions.logout();
                          }
                        });
                    }
                  }
                );
              });

            break;
        }
      });
  }

  async initWebsocketActions() {
    let sub1 = this.websocketActions
      .subscribeTo(SUBSCRIBE_TEETIME_BOOKING)
      .subscribe((data: any) => {});
    try {
      let sub2 = this.websocketActions
        .subscribeTo(SUBSCRIBE_COMP_MATCHPLAY_HOLE_SYNCED)
        .subscribe((data: any) => {});
      let sub3 = this.websocketActions
        .subscribeTo(SUBSCRIBE_COMP_MATCHPLAY_SUBMITTED)
        .subscribe((data: any) => {});
      let sub4 = this.websocketActions
        .subscribeTo(SUBSCRIBE_COMP_MATCHPLAY_UPDATED)
        .subscribe((data: any) => {});
      let sub5 = this.websocketActions
        .subscribeTo(SUBSCRIBE_COMP_MATCHPLAY_UPDATE_SCORER)
        .subscribe((data: any) => {});
      let sub6 = this.websocketActions
        .subscribeTo(SUBSCRIBE_COMP_SHOW_LEADERBOARD)
        .subscribe((data: any) => {});
      let sub7 = this.websocketActions
        .subscribeTo(SUBSCRIBE_COMP_SCORE_SYNCED)
        .subscribe((data: any) => {});
      let sub8 = this.websocketActions
        .subscribeTo(SUBSCRIBE_FLIGHT_CHANGE)
        .subscribe((data: any) => {});
      let sub9 = this.websocketActions
        .subscribeTo(SUBSCRIBE_DEVICE_LOCK_BROKEN)
        .subscribe((data: any) => {});
      let sub10 = this.websocketActions
        .subscribeTo(SUBSCRIBE_TEETIME_BOOKING)
        .subscribe((data: any) => {});
      Promise.all([sub1, sub2, sub3, sub4, sub5, sub6, sub7, sub8, sub9, sub10]).then(subs => {
        console.debug('subs', subs);
      });
    } catch {
      // setTimeout(() => {
      //   this.initWebsocketActions();
      // }, 500);
    }
    // setTimeout(()=>{
    //   setTimeout(()=>{
    //   },250)
    // },250)

    // await Promise.all([sub1, sub2, sub3, sub4, sub5, sub6, sub7, sub8, sub9, sub10])
  }

  clearWebsocketActions() {}
  public setPlayerInfo(fieldName: string, value: any) {
    this.store.dispatch(
      createAction(PlayerHomeActions.SET_PLAYER_INFO, {
        field: fieldName,
        value: value,
      })
    );
  }
  public updatePlayerProfile(
    player: PlayerInfo,
    updatingFriendProfile: boolean = false
  ): Observable<boolean> {
    let _dob = null;
    if (player.birthdate) _dob = moment(player.birthdate).format('YYYY-MM-DD');
    return this.playerService
      .updatePlayerProfile(
        player.email,
        player.firstName,
        player.lastName,
        player.gender,
        player.teeOffFrom,
        player.handicap,
        player.phone,
        _dob,
        player.playerId,
        player.countryId,
        player.nationalityId,
        player.password,
        player.defaultHandicapSystem
      )
      .pipe(
        map((result: ServerResult) => {
          if (result.success) {
            player.playerName = player.firstName + (player.lastName ? ' ' + player.lastName : '');
            if (!updatingFriendProfile) {
              this.store.dispatch(createAction(PlayerHomeActions.UPDATE_PLAYER_PROFILE, player));
              this.setNeedRefresh(true);
            }
          }
          return result.success;
        })
      );
  }
  public uploadPlayerInsuranceDocument(
    imageURL: string,
    contentType: string,
    playerId: number,
    params?: any,
    mode?: string,
    file?: any
  ): Observable<any> {
    let _mode = mode;
    let _authToken;
    let _insuranceId;
    this.sessionService.getAuthToken().subscribe(data => {
      _authToken = data;
    });
    if (_mode === 'edit') {
      _insuranceId = params ? params.insuranceId : null;
      if (!_insuranceId) return;
      return this.flightService
        .updatePlayerInsuranceDocument(
          imageURL,
          contentType,
          playerId,
          _insuranceId,
          _authToken,
          params,
          file
        )
        .pipe(
          map((uploadResult: any) => {
            let data: any;
            console.debug('after player insurance [1] : ', uploadResult);
            data = uploadResult;
            // data = JSON.parse(JSON.stringify(uploadResult.message));
            console.debug('after player insurance [1] : ', uploadResult, data);

            return data;
          })
        );
    } else {
      return this.flightService
        .addPlayerInsuranceDocument(imageURL, contentType, playerId, _authToken, params, file)
        .pipe(
          map((uploadResult: any) => {
            let data: any;
            console.debug('after player insurance [2] : ', uploadResult);
            data = uploadResult;
            // data = JSON.parse(JSON.stringify(uploadResult.message));
            console.debug('after player insurance [2] : ', uploadResult, data);

            return data;
          })
        );
    }
  }

  /**
   * Update the player photo
   * @param imageURL The ULR of the image to upload
   * @param contentType The mime type of the image
   * @param playerId The id of the player.
   * @param friend Specifies whether friend's photo is updated
   * @returns {Observable<R>}
   */
  public updatePlayerPhoto(
    imageURL: string,
    contentType: string,
    playerId: number,
    friend: boolean = false
  ): Observable<PlayerInfo> {
    return this.playerService.updatePlayerPhoto(imageURL, contentType, playerId).pipe(
      map((uploadResult: UploadResult) => {
        let playerInfo: PlayerInfo;
        let errMsg: PlayerInfo;

        playerInfo = JSON.parse(JSON.stringify(uploadResult.message));

        // errMsg = JSON.parse(JSON.stringify(uploadResult.message));
        // playerInfo.errorMessage = errMsg.errorMessage;
        // playerInfo.errorMessage = JSON.parse(JSON.stringify(uploadResult.message));

        JsonService.deriveFullUrl(playerInfo, 'photoUrl');
        JsonService.deriveFullUrl(playerInfo, 'thumbnail');
        if (!friend) {
          //The upload result message is player info
          this.store.dispatch(createAction(PlayerHomeActions.UPDATE_PLAYER_PROFILE, playerInfo));
        }
        return playerInfo;
      })
    );
  }
  public uploadPlayerCardDiscount(
    imageURL: string,
    contentType: string,
    playerDiscountProgramId: number
  ): Observable<any> {
    let _authToken;
    this.sessionService.getAuthToken().subscribe(datas => {
      _authToken = datas;
    });
    return this.flightService
      .updatePlayerCardDocument(imageURL, contentType, playerDiscountProgramId, _authToken)
      .pipe(
        map((uploadResult: UploadResult) => {
          let data: any;
          data = JSON.parse(JSON.stringify(uploadResult));
          // let playerInfo: PlayerInfo;
          // let errMsg: PlayerInfo;

          // playerInfo = JSON.parse(JSON.stringify(uploadResult.message));
          // // errMsg = JSON.parse(JSON.stringify(uploadResult.message));
          // // playerInfo.errorMessage = errMsg.errorMessage;
          // // playerInfo.errorMessage = JSON.parse(JSON.stringify(uploadResult.message));

          // JsonService.deriveFullUrl(playerInfo, "photoUrl");
          // JsonService.deriveFullUrl(playerInfo, "thumbnail");
          return data;
        })
      );
  }

  public addPlayerType(
    imageURL: string,
    contentType: string,
    playerId: number,
    bookingPlayerType: string
  ): Observable<any> {
    let _authToken;
    this.sessionService.getAuthToken().subscribe(data => {
      _authToken = data;
    });
    return this.flightService
      .addPlayerType(imageURL, contentType, playerId, bookingPlayerType, _authToken)
      .pipe(
        map((uploadResult: UploadResult) => {
          let data: any;
          data = JSON.parse(JSON.stringify(uploadResult.message));
          return data;
        })
      );
  }

  public setNeedRefresh(needRefresh: boolean) {
    this.store.dispatch(createAction(PlayerHomeActions.SET_NEED_REFRSH, needRefresh));
  }
  public setState(state: string) {
    this.store.dispatch(createAction(PlayerHomeActions.SET_HOME_STATE, state));
  }
  public selectCompetionForScoring(compId: number) {
    this.store.dispatch(createAction(PlayerHomeActions.SELECT_COMPETITION_FOR_SCORING, compId));
    this.setNeedRefresh(true);
  }
  public fetchCurrentScorecard(
    playerHomeInfo: PlayerHomeInfo,
    type?: string
  ): Observable<PlainScoreCard> {
    //Check the current scorecard
    this.setState('Checking scorecard...');
    // setTimeout(()=>{
    //     this.setState("");
    // }, 5000);
    // this.currScorecardActions.fetchCurrent(playerHomeInfo.playerId).subscribe((data)=>{
    this.setState('');
    //     return data
    // }, (error)=>{
    //     // return error
    // }, ()=>{
    //     // return data
    // })
    return this.currScorecardActions.fetchCurrent(playerHomeInfo.playerId, type);
  }

  public checkScorecard(scorecard: PlainScoreCard) {
    if (scorecard.competition) {
      this.checkCompetitionScoring(scorecard);
    } else {
      //Normal game scorecard found. Reset state
      this.store.dispatch(createAction(PlayerHomeActions.RESET_STATE));
    }
  }

  public checkCompetitionScoring(scorecard?: PlainScoreCard) {
    this.store
      .select((appState: any) => appState.reducers.playerHomeData)
      .pipe(filter(Boolean))
      .pipe(take(1)) //very important
      .subscribe((playerHomeData: PlayerHomeData) => {
        this._checkCompScoring(playerHomeData, scorecard);
      });
  }

  private _checkCompScoring(playerHomeData: PlayerHomeData, scorecard: PlainScoreCard) {
    let activeComps: CompetitionInfo[] = playerHomeData.playerHome.compsActiveToday;
    if (activeComps && activeComps.length) {
      if (activeComps.length > 1) {
        //check whether the competition is already selected
        let compSelected = null;
        if (playerHomeData.competitionSelectedForScoring) {
          compSelected = playerHomeData.playerHome.compsActiveToday
            .filter(comp => comp.competitionId === playerHomeData.competitionSelectedForScoring)
            .pop();
        }
        console.debug('[Player-Id] Prepare comp scoring ', playerHomeData.playerHome);
        if (compSelected)
          this._prepareCompetitionScoring(
            compSelected,
            playerHomeData.playerHome.player.playerId,
            scorecard
          );
        this.setState('');
      } else {
        //Only one competition active. Select that and continue
        //Check whether normal game is on
        // this.currScorecardService.normalGameScoring().take(1)
        //     .subscribe((normalGameOn: boolean)=>{
        //         if(!normalGameOn)
        //             this._prepareCompetitionScoring(activeComps[0], playerHomeData.playerHome.player.playerId);
        //     });
      }
    } else {
      //Reset the home state
      // this.currScorecardActions.cancelGame(playerHomeData.playerHome.player.playerId);
      this.store.dispatch(createAction(PlayerHomeActions.RESET_STATE));
      if (scorecard && scorecard.competition) {
        //Clear the current scorecard
        this.currScorecardActions.currentGameFinished(playerHomeData.playerHome.playerId);
      } else {
        this.currScorecardService
          .getCurrentScorecard()
          .pipe(take(1))
          .subscribe((curr: CurrentScorecard) => {
            if (curr.scorecard && curr.scorecard.competition) {
              //Clear the current scorecard
              this.currScorecardActions.currentGameFinished(playerHomeData.playerHome.playerId);
            }
          });
      }
    }
  }

  private _prepareCompetitionScoring(
    comp: CompetitionInfo,
    playerId: number,
    scorecard?: PlainScoreCard
  ) {
    if (!scorecard) {
      //fetch the scorecard for the competition
      console.debug('[Player-Id] Prepare comp scoring ', playerId);
      this.competitionService
        .getOrCreateScorecard(comp.competitionId, false, playerId)
        .subscribe((scorecard: PlainScoreCard) => {
          this.currScorecardActions.setCurrentScorecard(scorecard, playerId);
          this.store.dispatch(
            createAction(PlayerHomeActions.SET_SELECTED_COMPETITION, {
              competitionName: scorecard.competitionName,
              startingHole: scorecard.startingHole,
              startTime: scorecard.startTime,
            })
          );
          this.setState('');
        });
    } else {
      this.setState('');
    }
  }

  public getCompetitionScoring(comp, playerId: number, loader?) {
    // this.setState("Getting Scorecard...")
    console.debug('[Player-Id] get comp scoring ', playerId);
    this.competitionService.getOrCreateScorecard(comp, true, playerId).subscribe(
      (scorecard: PlainScoreCard) => {
        console.debug('getting scorecard home action [1] : ', scorecard);
        this.currScorecardActions.setCurrentScorecard(scorecard, playerId);
        this.store.dispatch(
          createAction(PlayerHomeActions.SET_SELECTED_COMPETITION, {
            competitionName: scorecard.competitionName,
            startingHole: scorecard.startingHole,
            startTime: scorecard.startTime,
          })
        );

        if (scorecard && loader) loader.dismiss();
        // this.setState("");
        // if (loader) loader.dismiss();
      },
      error => {
        if (loader) loader.dismiss();
      },
      () => {
        // if(loader) loader.dismiss();
      }
    );
  }

  public clearState() {
    this.setState('');
  }

  // private selectCompetitionForScoring(competitionId: number) {
  //     this.store.dispatch(createAction(PlayerHomeActions.SELECT_COMPETITION_FOR_SCORING, competitionId));
  // }

  public clearAllStates() {
    this.store.dispatch(createAction(PlayerHomeActions.CLEAR_ALL_STATES));
  }
}
